import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ControlItemsService,
  TenantService,
  UserService,
} from '../../_services/index';

import {ComplianceArea, User} from '../../_models/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";


import {LoginHelper, Recurring, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PolicyService} from "../../_services/policy.service";
import {DocumentSelectComponent} from "../documentSelect";
import {IndexConfigService} from "../../_services/index.config.service";
import {Constants} from "../../helpers/constants";
import {fromByteArray} from "base64-js";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {ListMessageComponent} from "../listMessage";
import {ExportPolicyComponent} from "../exportPolicy/exportPolicy.component";
import {ConfirmComponent} from "../confirm";
import {PolicyApprovalStatus} from '../../_models/policyApprovalStatus';
import {ReplacePolicyTextComponent} from "../replacePolicyText/replace-policy-text.component";
import {InspectionProfileService} from "../../_services/inspectionProfile.service";
import {EvidenceCentralService} from "../../_services/evidenceCentral.service";
import {SelectEvidenceCentralItemComponent} from "../selectEvidenceCentralItem/select-evidenceCentralItem.component";
import {forkJoin} from "rxjs";
import {SelectDictionaryItemComponent} from "../selectDictionaryItem/select-dictionary-item.component";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "policy-component",
  templateUrl: 'policy.component.html',
  styleUrls: ['./policy.component.scss'],
})

export class PolicyComponent implements OnInit {
  api = window.location.origin;
  policyForms: FormGroup[] = [];
  selectedItems: any[] = [];
  items: any[];
  policyId: number = null;
  policies = [];
  canEdit: boolean = false;
  tenantName: string;
  recurringList: any[];
  displayProfile: boolean;
  inspectionProfileSets: any[];
  comparisonText: string = '';
  comparisonResult: string = '';
  approvalCols : any[] = [
    {field: 'startDate', header: 'Period'},
    {field: 'approver', header: 'Approver'},
    {field: 'status', header: 'Approval Status', width: '40px'},
    {field: 'note', header: 'Note', width: '200px'},
  ];
  highlightedPolicySectionId = null;

  revisionHistoryCols : any[] = [
    {field: 'date', header: 'Date'},
    {field: 'description', header: 'Description'},
    {field: 'author', header: 'Author'},
  ];
  users: User[] = [];
  isMaster: boolean = false;
  settings: any;
  controlItems = [];
  controlItemMap = {};
  evidenceCentralItems = [];
  complianceAreas: ComplianceArea[] = [];
  selectedAreas = [];
  domains: string[] = [];
  selectedDomains: string[] = [];
  expandedSections = {};
  PolicyApprovalStatus = {
    None: PolicyApprovalStatus.None,
    Rejected: PolicyApprovalStatus.Rejected,
    Approved: PolicyApprovalStatus.Approved
  };
  inspectionProfilesMap = {};
  inspectionProfileSetsMap = {};

  constructor(
    public config: IndexConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService,
    public controlItemService: ControlItemsService,
    public complianceAreaService: ComplianceAreaService,
    public inspectionProfileService: InspectionProfileService,
    public evidenceCentralService: EvidenceCentralService,
    public policyService: PolicyService) {
    this.recurringList = [];
    for (let i = Recurring.Monthly; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }
  }

  initForm(value) {
    const controls = {
      name: this._formBuilder.control(['', Validators.required]),
      text: this._formBuilder.control(['']),
      ownerId: this._formBuilder.control(null),
      approvalOwnerId: this._formBuilder.control(null),
      frequency: this._formBuilder.control(Recurring.Yearly),
      id: this._formBuilder.control(null),
      order: this._formBuilder.control(null),
      startDate: this._formBuilder.control(null),
      approvals: this._formBuilder.control(null),
      view: this._formBuilder.control([false]),
      modifiedBy: this._formBuilder.control(null),
      modifiedDate: this._formBuilder.control(null),
      authors: this._formBuilder.control(null),
      authorList: this._formBuilder.control(null),
      notes: this._formBuilder.control(null),
      status: this._formBuilder.control(null),
      versions: this._formBuilder.control(null),
      parentId: this._formBuilder.control(null),
      versionName: this._formBuilder.control(null),
      newVersionName: this._formBuilder.control(null),
      isActive: this._formBuilder.control(null),
      activeVersion: this._formBuilder.control(null),
      assignedTo: this._formBuilder.control(null),
      controlIds: this._formBuilder.control(['']),
      controlIdList: this._formBuilder.control([[]]),
      domain: [''],
      revisionHistories: [],
      policySections: this._formBuilder.array((value.policySections || []).map((s, i) => this.initPolicySectionForm(s, i + 1))),
      updateDetails: this._formBuilder.control('')
    };

    const policyForm = this._formBuilder.group(controls);
    policyForm.patchValue({...value, newVersionName: ''});
    return policyForm;
  }

  initPolicySectionForm(value, number) {
    const controls = {
      title: [''],
      text: [''],
      order: [number],
      controlIds: [''],
      controlIdList: [[]],
      domain: [''],
      policySectionId: [0],
      policyId: [0],
      subTitle: [''],
      number: [''],
      subNumber: [''],
      evidenceCentralItems: this._formBuilder.control([]),
    };

    const policyForm = this._formBuilder.group(controls);
    //policyForm.setValue(value);
    return policyForm;
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
      (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0;

    this.complianceAreaService.getInfoComplianceAreas().subscribe(complianceAreas => {
      this.complianceAreas = complianceAreas;
    });

    this.route.params.subscribe(p => {
      this.policyId = p['policyId'];
    })
    this.isMaster = this.tenantName == Constants.RiskSpongeMaster;
    this.controlItemService.getAll().subscribe(s => {
      this.controlItems = s;
      s.forEach(c => {
        this.controlItemMap[c.controlItemId] = c;
      });
    });
    this.userService.getActiveShort(this.tenantName).subscribe(u => {
      this.users = u;
      this.loadPolicies();
      this.loadSettings();
    });
    this.evidenceCentralService.getAll().subscribe(e => this.evidenceCentralItems = e);
  }

  loadPolicies() {
    forkJoin(
    this.policyService.getAllPolicysFull(),
      this.evidenceCentralService.getAll(),
      this.inspectionProfileService.getAll()
    ).subscribe(t => {
      this.policies = t[0];
      this.evidenceCentralItems = t[1];
      this.inspectionProfileSets = [];
      t[2].forEach(i => {
        let set = this.inspectionProfileSets.find(e => e.inspectionProfileSetId == i.inspectionProfileSetId);
        if (!set) {
          set = {inspectionProfileSetId: i.inspectionProfileSetId, name: i.setName || 'Default', inspectionProfiles: []};
          this.inspectionProfileSets.push(set);
        }
        set.inspectionProfiles.push(i);
      });
      this.inspectionProfileSetsMap = {};
      this.inspectionProfilesMap = {};
      var allDomains = this.policies.map(p => p.domain || '');
      this.domains = allDomains.filter((p, i) => allDomains.indexOf(p) === i);
      this.selectedItems.push(this.policies.find(t => t.id == this.policyId) || (this.policyId == 0 ? this.policies[this.policies.length - 1] : this.policies[0]));
      this.policyForms = [];
      this.policies.forEach(p => {
        let i;
        p.ownerName = this.getFullNameById(p.ownerId);

        (p.policySections || []).forEach(s => {
          this.inspectionProfilesMap[s.policySectionId] = this.inspectionProfilesMap[s.policySectionId] || {};
          this.inspectionProfileSetsMap[s.policySectionId] = this.inspectionProfileSetsMap[s.policySectionId] || {};
            (s.evidenceCentralItems || []).forEach(e => {
              const inspectionProfileId = this.evidenceCentralItems.find(d => d.id === e.id)?.inspectionProfileId;
              if (inspectionProfileId) {
                this.inspectionProfilesMap[s.policySectionId][inspectionProfileId] = true;
                this.inspectionProfileSetsMap[s.policySectionId][this.inspectionProfileSets.find(e => e.inspectionProfiles.find(p => p.id === inspectionProfileId))?.inspectionProfileSetId] = true;
              }
          });
        });

        const closest = moment(p.startDate || new Date());
        const step = p.frequency == Recurring.Yearly ? {step: 'year', value: <any>1} :
          p.frequency == Recurring.Quarterly ? {step: 'month', value: <any>3} :
            p.frequency == Recurring.Monthly ? {step: 'month', value: 1} : {step: 'y', value: <any>1};
        const previousVariants = [];
        while (closest.clone().add(step.value, step.step).isBefore(moment())) {
          closest.add(step.value, step.step);
          previousVariants.push({approverId: p.approvalOwnerId, startDate: closest.format('Y-MM-DDT00:00:00')});
        }
        let currentApproval;
        for (i = 0; i < p.approvals.length; i++) {
          if (moment(p.approvals[i].startDate).isSameOrAfter(closest, 'day')) {
            currentApproval = p.approvals[i];
          }
        }
        p.approvals = p.approvals || [];
        for (i = Math.max(previousVariants.length - 4, 0); i < (previousVariants.length - 1); i++) {
          if (!p.approvals.find(a => moment(a.startDate).isSameOrAfter(previousVariants[i].startDate, 'day'))) {
            p.approvals.push(previousVariants[i]);
          }
        }
        if (!currentApproval && p.approvalOwnerId) {
          p.approvals.push({approverId: p.approvalOwnerId, startDate: closest.format('Y-MM-DDT00:00:00')});
        }
        p.approvalOwnerId = null;
        p.authorList = ((p.authors || '').split(',') || []).filter(t => t != '').map(t => this.users.find(u => u.userId == t)).filter(u => u);
        (p.policySections || []).forEach(s => s.controlIdList = (s.controlIds || '').split(',').filter(d => d != ''));
        p.controlIdList = (p.controlIds || '').split(',').filter(d => d != '')
        p.versions.forEach(v => {
          let i;
          v.activeVersion = p.id;
          v.view = true;
          v.authorList = ((v.authors || '').split(',') || []).filter(t => t != '').map(t => this.users.find(u => u.userId == t)).filter(u => u);
          (v.policySections || []).forEach(s => s.controlIdList = (s.controlIds || '').split(',').filter(d => d != ''));
          v.controlIdList = (v.controlIds || '').split(',').filter(d => d != '')
          let currentApproval;
          for (i = 0; i < v.approvals.length; i++) {
            if (moment(v.approvals[i].startDate).isSameOrAfter(closest, 'day')) {
              currentApproval = v.approvals[i];
            }
          }
          for (i = Math.max(previousVariants.length - 4, 0); i < (previousVariants.length - 1); i++) {
            if (!v.approvals.find(a => moment(a.startDate).isSameOrAfter(previousVariants[i].startDate, 'day'))) {
              v.approvals.push(previousVariants[i]);
            }
          }
          if (!currentApproval && v.approvalOwnerId) {
            v.approvals.push({approverId: v.approvalOwnerId, startDate: closest.format('Y-MM-DDT00:00:00')});
          }
        });
        this.policyForms.push(this.initForm(p.versions.find(v => v.id == p.id)));
        this.filterPolicies();
      });
    });
  }

  save(i) {
    this.policyForms[i].controls['newVersionName'].setValidators([]);
    this.policyForms[i].controls['newVersionName'].updateValueAndValidity();
    if (this.policyForms[i].valid) {
      const result = this.policyForms[i].value;
      const duplicate = result.policySections.find(s => result.policySections.find(ss => s !== ss && s.number === ss.number && s.subNumber === ss.subNumber));
      if (duplicate) {
        this.dialog.open(ConfirmComponent, {
          data: {
            title: 'There are duplicate numbers in the poilcy. Do you want to save it?',
            yes: 'Yes',
            no: 'No',
            confirm: (isChecked) => this.doSave(i),
            cancel: () => {
            }
          }
        });
      } else {
        this.doSave(i);
      }
    }
  }

  doSave(i) {
    const result = this.policyForms[i].value;
    result.text = fromByteArray(new TextEncoder().encode(result.text || ''));
    result.policySections.forEach((s, i) => {
      s.controlIds = s.controlIdList.join(',');
    });
    result.controlIds = result.controlIdList.join(',');
    result.approvals = (result.approvals || []).filter(a => a.status || a.policyApprovalId);
    result.authors = (result.authorList || []).map(a => a.userId).join(',');
    result.revisionHistories = this.policies[i].revisionHistories;
    this.policyService.savePolicy(result).subscribe(() => {
      this.policies[i] = result;
      this.selectedItems.push(result);
      this.alertService.success("Successfully saved");
      this.loadPolicies();
    });
  }

  saveAsNew(i) {
    this.policyForms[i].controls['newVersionName'].setValidators(Validators.required);
    this.policyForms[i].controls['newVersionName'].markAsTouched();
    this.policyForms[i].controls['newVersionName'].updateValueAndValidity();
    if (this.policyForms[i].valid) {
      const result = this.policyForms[i].value;
      result.id = null;
      result.versionName = result.newVersionName;
      (result.policySections || []).forEach(s => s.policySectionId = null);
      result.parentId = this.policies[i].id;
      result.text = fromByteArray(new TextEncoder().encode(result.text || ''));
      result.authors = (result.authorList || []).map(a => a.userId).join(',');
      result.revisionHistories = this.policies[i].revisionHistories;
      this.policyService.savePolicy(result).subscribe(() => {
        this.policies[i] = result;
        this.selectedItems.push(result);
        this.alertService.success("Successfully saved");
        this.loadPolicies();
      });
    }
  }

  add() {
    const newForm = this.initForm({
      name: "",
      text: "",
      id: 0,
      ownerId: null,
      approvalOwnerId: null,
      frequency: null,
      order: 0,
      startDate: null,
      approvals: null,
      view: false,
      modifiedBy: null,
      modifiedDate: null,
      authors: null,
      notes: '',
      authorList: null,
      status: null,
      versions: null,
      parentId: null,
      versionName: null,
      newVersionName: null,
      isActive: null,
      activeVersion: null,
      controlIds: '',
      controlIdList: [],
      assignedTo: [],
      policySections: [],
      revisionHistories: [],
      updateDetails: ''
    });
    (<any>newForm).nameVisible = true;
    this.policyForms.push(newForm);
    const newVal = {name: "", text: "", id: 0};
    this.policies.push(newVal);
    this.selectedItems.push(newVal);
  }

  selectDocument(node) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {}
    };

    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const quill = window['quills'].find(q => q.container === node.closest(".p-editor-container").querySelector(".ql-container"));
        const url = this.config.api + "/api/attachments/file?name=" + encodeURIComponent(result._orgData.name) + "&path=" + (result._orgData.folderId || "");
        quill.format('link', url, 'user');
      }
    });
  }

  dropPolicy(item) {
    if (item.id) {
      this.policyService.deletePolicy(item.id).subscribe(() => this.loadPolicies());
    } else {
      this.policies = this.policies.filter(p => p != item);
    }
  }

  getFullName(user) {
    if (!user) {
      return '';
    }
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  getFullNameById(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return null;
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress || user.emailAddress;
  }

  loadSettings() {
    this.clientProfileService.getSettings(this.tenantName).subscribe(t => this.settings = t);
  }

  isDefaultUpdate(area, event) {
    if (event.checked) {
      this.settings.defaultPolicies.push(area.id);
    } else {
      this.settings.defaultPolicies = this.settings.defaultPolicies.filter(a => a != area.id);
    }
    this.clientProfileService.saveSettings(this.settings, this.tenantName).subscribe(() => this.loadSettings());
  }

  up(item) {
    const i = this.policies.indexOf(item);
    this.policies[i] = this.policies[i - 1];
    this.policies[i - 1] = item;
    this.policyService.setPolicyOrder(this.policies.map(p => p.id)).subscribe(() => {
      this.loadPolicies();
    })
  }

  down(item) {
    const i = this.policies.indexOf(item);
    this.policies[i] = this.policies[i + 1];
    this.policies[i + 1] = item;
    this.policyService.setPolicyOrder(this.policies.map(p => p.id)).subscribe(() => {
      this.loadPolicies();
    })
  }

  saveOrder(e) {
    this.policyService.setPolicyOrder(this.policies.map(p => p.id)).subscribe(() => {
      this.loadPolicies();
    })
  }

  selectVersion(event, formId) {
    const policy = this.policies[formId].versions.find(v => v.id == event.value);
    policy.activeVersion = event.value;
    this.policyForms[formId] = this.initForm(policy)
  }

  setActive(formId) {
    this.policyService.setActive(this.policyForms[formId].value.id).subscribe(() => this.loadPolicies());
  }

  setInactive(formId) {
    this.policyService.setInactive(this.policyForms[formId].value.id).subscribe(() => this.loadPolicies());
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  addSection(policyForm) {
    const sectionArray = policyForm.get('policySections') as FormArray;
    sectionArray.push(this.initPolicySectionForm({}, sectionArray.length + 1));
  }

  deletePolicySection(policyForm, index) {
    (policyForm.get('policySections') as FormArray).removeAt(index);
  }

  insertPolicySectionContent(policyForm, index) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        dictionary: 'PolicyContent',
        group: 'securityTopic'
      }
    };

    const selectDialogRef = this.dialog.open(SelectDictionaryItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        var control = (policyForm.get('policySections') as FormArray).at(index);
        control.patchValue({text: control.value.text + ' ' + data.details});
      }
    });
  }

  addControl(formControl) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: formControl.value || []
      }
    };

    const selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        formControl.setValue([...formControl.value, data.controlItemId]);
      }
    });

  }

  removeControl(formControl, controlId) {
    formControl.setValue(formControl.value.filter(i => i != controlId));
  }

  addEvidenceCentralItem(formControl) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: formControl.value || []
      }
    };

    const selectDialogRef = this.dialog.open(SelectEvidenceCentralItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        formControl.setValue([...formControl.value, {id: data.id, name: data.name}]);
      }
    });

  }

  removeEvidenceCentralItem(formControl, evidenceCentralItem) {
    formControl.setValue(formControl.value.filter(i => i.id != evidenceCentralItem.id));
  }

  importPolicy(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.policyService.importPolicy(file, false).subscribe(
        (res) => {
          if (res && res.overwriteExpected) {
            let config: MatDialogConfig = {
              panelClass: 'custom-overlay-pane-class',
              width: 'auto',
              height: 'auto',
              data: {
                title: 'Duplicate policy name(s) found. Do you wish to overwrite?',
                yes: 'Yes',
                no: 'No',
                confirm: () => this.doImportPolicy(event),
                cancel: () => {
                },
              }
            };
            this.dialog.open(ConfirmComponent, config);
          } else {
            let config: MatDialogConfig = {
              panelClass: 'custom-overlay-pane-class',
              width: 'auto',
              height: '90%',
              data: {
                items: res,

                title: "Import report"
              }
            };
            this.dialog.open(ListMessageComponent, config);
            this.loadPolicies();
          }
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  doImportPolicy(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.policyService.importPolicy(file, true).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadPolicies();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }


  public filterPolicies() {
    const map = this.controlItemMap;
    const selected = this.selectedAreas;
    this.policyForms.forEach(p => {
      (<any>p).hidden = !(selected.length == 0 || (p.value.controlIdList || []).find(c => selected.find(a => a == map[c].complianceAreaId)) || (p.value.policySections || []).find(s => (s.controlIdList || []).find(c => selected.find(a => a == map[c].complianceAreaId))))
      || !(this.selectedDomains.length === 0 || this.selectedDomains.indexOf(p.value.domain) >= 0);
      console.log((<any>p).hidden);
    });
  }

  saveSectionOrder(form) {
    (<FormArray>(form.controls['policySections'])).controls.forEach((c, i) => {
      (<FormGroup>c).controls['order'].setValue(i + 1);
    });
  }

  addRevision(policy) {
    policy.revisionHistories = policy.revisionHistories || [];
    policy.revisionHistories = [...policy.revisionHistories, {isEdit: true, date: new Date()}];
  }

  editName(item, form) {
    form.originalName = item.name;
    form.nameVisible = true;
  }

  cancelEditName(item, form) {
    form.nameVisible = false;
    form.controls['name'].setValue(form.originalName);
  }

  GetFullName(userId) {
    return (this.users.find(u => u.userId == userId) || <any>{}).fullName || '';
  }

  removeRevision(policy, item) {
    policy.revisionHistories = policy.revisionHistories.filter(r => r != item);
  }

  exportPolicy(policyId) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '300px',
      height: 'auto',

      data: {
        policyId: policyId
      }
    };

    this.dialog.open(ExportPolicyComponent, config);

  }

  compare(i){
    this.comparisonResult = '';
    this.policyService.compare(this.policyForms[i].value.policySections.map(s => s.text.replace(/\<[^<]*\>/g, ' ')).join('\r\n'), this.comparisonText).subscribe(s => {
      var content = JSON.parse(s.result).message.content;
      //var result = JSON.parse(content);
      this.comparisonResult = content;
    });
  }

  openReplace(i) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '300px',
      height: 'auto',

      data: {
        policyForm: this.policyForms[i]
      }
    };

    var dialogRef = this.dialog.open(ReplacePolicyTextComponent, config);
  }
}
